const APP_NAME_MAP: Record<string, string> = {
  weather: 'Roam Weather',
  trails: 'Roam Trails',
  office: 'Roam Office',
  // Add new apps here
};

export function getAppName(redirectUrl?: string): string {
  if (!redirectUrl) return 'Roam account';

  let appId: string | null = null;

  // iOS custom scheme: com.roamapps.weather://auth-callback
  const schemeMatch = redirectUrl.match(/^com\.roamapps\.(\w+):\/\//);
  if (schemeMatch) {
    appId = schemeMatch[1];
  }

  // Android deep link: http://roam-weather/...
  if (!appId) {
    const androidMatch = redirectUrl.match(/^https?:\/\/roam-(\w+)/);
    if (androidMatch) {
      appId = androidMatch[1];
    }
  }

  // Web URL: https://weather.roamapps.com/...
  if (!appId) {
    try {
      const url = new URL(redirectUrl);
      const hostMatch = url.hostname.match(/^(\w+)\.roamapps\.com$/);
      if (hostMatch && hostMatch[1] !== 'accounts') {
        appId = hostMatch[1];
      } else if (!url.hostname.endsWith('.roamapps.com')) {
        // Non-roamapps domain — display the hostname directly
        return url.hostname;
      }
    } catch {
      // Not a valid URL, ignore
    }
  }

  if (!appId) return 'Roam account';

  // Check hardcoded map first, then fall back to capitalized identifier
  return APP_NAME_MAP[appId] ?? `Roam ${appId.charAt(0).toUpperCase() + appId.slice(1)}`;
}
